module.exports = __webpack_public_path__ + "img/helmet-login.4d66bb0d.svg";